export const PLATFORM_APP = {
  PLATFORM: "Platform",
  CRM_MODULE: {
    CRM: "CRM",
    FEATURES: {
      COMPETITOR_ROLE: "CompetitorRole",
      COMPETITOR_THREAT_LEVEL: "CompetitorThreatLevel",
      CONSENT_STATUS: "ConsentStatus",
      CRM_STATUS: "CRMStatus",
      CUSTOMER_CATEGORY: "CustomerCategory",
      CUSTOMER_STATUS: "CustomerStatus",
      CUSTOMER_TYPE: "CustomerType",
      INQUIRY_DISPOSITION: "InquiryDisposition",
      LEAD_QUALIFICATION_STATUS: "LeadQualificationStatus",
      OPPORTUNITY_STAGE: "OpportunityStage",
      PERSON_TITLE: "PersonTitle",
    },
  },
};

export const CRM_APP = {
  CRM: "CRM",
  CONFIG_MODULE: {
    CONFIG: "Config",
    FEATURES: {
      COMPETITOR: "Competitor",
      COMPETITOR_ANALYSIS: "CompetitorAnalysis",
      IDEAL_CUSTOMER_PROFILE: "IdealCustomerProfile",
      MARKET: "Market",
      PRIVACY_CONSENT: "PrivacyConsent",
      PRODUCT_CONFIG: "ProductConfig",
      PRODUCTS: "Products",
      SALES_REGION: "SalesRegion",
      SALES_TERRITORY: "SalesTerritory",
      SERVICES: "Services",
    },
  },
  GENERATE_MODULE: {
    GENERATE: "Generate",
    FEATURES: {
      CAMPAIGN_MANAGEMENT: "CampaignManagement",
      INQUIRY_MANAGEMENT: "InquiryManagement",
      LEAD_MANAGEMENT: "LeadManagement",
      PROSPECT_MANAGEMENT: "ProspectManagement",
      STATUS_HISTORY: "StatusHistory",
    },
  },
  ORCHESTRATE_MODULE: {
    ORCHESTRATE: "Orchestrate",
    FEATURES: {
      OPPORTUNITY_MANAGEMENT: "OpportunityManagement",
      WON_CONTRACT: "WinContract",
      WON_ORDER: "WinOrder",
    },
  },
  RELATE_MODULE: {
    RELATE: "Relate",
    FEATURES: {
      CONTACT: "Contact",
      CUSTOMER_ACCOUNT: "CustomerAccount",
      CUSTOMERS: "Customers",
    },
  },
};

export const SETUP_APP = {
  SETUP: "Setup",
  CRM_MODULE: {
    CRM: "CRM",
    FEATURES: {
      ACCOUNT_CATEGORY: "AccountCategory",
      ACCOUNT_TYPE: "AccountType",
      ACTIVITY: "Activity",
      ACTIVITY_STATUS: "ActivityStatus",
      ADDRESS_TYPE: "AddressType",
      ASSIGNMENT_TYPE: "AssignmentType",
      BILLING_FREQUENCY: "BillingFrequency",
      BUDGET_STATUS: "BudgetStatus",
      BUSINESS_NEED_STATUS: "BusinessNeedStatus",
      CAMPAIGN: "Campaign",
      CHANNEL_STATUS: "ChannelStatus",
      CLOSURE_REASON: "ClosureReason",
      COMPANY_SIZE: "CompanySize",
      COMPETITOR_STATUS: "CompetitorStatus",
      COMPETITOR_TYPE: "CompetitorType",
      CONSENT_SOURCE: "ConsentSource",
      CONTACT_DEPARTMENT: "ContactDepartment",
      CONTACT_METHOD: "ContactMethod",
      CONTACT_ROLE: "ContactRole",
      CONTACT_STATUS: "ContactStatus",
      CONTACT_TYPE: "ContactType",
      CONTRACT_CATEGORY: "ContractCategory",
      CONTRACT_STATUS: "ContractStatus",
      CONTRACT_TYPE: "ContractType",
      CUSTOMER_CURRENCY: "CustomerCurrency",
      DECISION_AUTHORITY: "DecisionAuthority",
      DISQUALIFICATION_REASON: "DisqualificationReason",
      ENGAGEMENT_LEVEL: "EngagementLevel",
      INFLUENCE_LEVEL: "InfluenceLevel",
      INQUIRY_TYPE: "InquiryType",
      INTENT_LEVEL: "IntentLevel",
      LEAD_QUALIFICATION_MATURITY: "LeadQualificationMaturity",
      LEAD_TYPE: "LeadType",
      NURTURE_REASON: "NurtureReason",
      OPPORTUNITY_TYPE: "OpportunityType",
      ORDER_TYPE: "OrderType",
      PAYMENT_TERM: "PaymentTerm",
      PREFERRED_LANGUAGE: "PreferredLanguage",
      PRIORITY: "Priority",
      PROCUREMENT_STATUS: "ProcurementStatus",
      PROSPECT_TYPE: "ProspectType",
      PURCHASE_TIMELINE: "PurchaseTimeline",
      QUALIFICATION_READINESS: "QualificationReadiness",
      RELATIONSHIP_STATUS: "RelationshipStatus",
      RESPONSE_STATUS: "ResponseStatus",
      SEGMENT_TYPE: "SegmentType",
      SENIORITY_LEVEL: "SeniorityLevel",
      SOURCE: "Source",
      TIMELINE_STATUS: "TimelineStatus",
      WIN_LOSS_REASON: "WinLossReason",
    },
  },
};
